export function getDateMin() {
    let dateMin = new Date();
    dateMin.setFullYear(dateMin.getFullYear() - 18);
    return dateMin;
}

export function getYearArray(date) {
    return Array.from({ length: date.getFullYear() - 1899 }, (_, i) => date.getFullYear() - i);
}

export function getDay(date) {
    let d = date.getDate();
    if (d <= 9) {
        d = '0'.concat(d);
    }
    return d;
}

export function getMonthNumber(date) {
    return date.getMonth() < 10 ? '0'.concat(date.getMonth() + 1) : date.getMonth() + 1;
}

export function getFullYear(date) {
    return date.getFullYear();
}
